import React, { FC, ReactElement } from "react";

import { GrayBox } from "./styled";

import { PlaceholderProps } from "./types";

export const Placeholder: FC<PlaceholderProps> = ({ children, width }) => {
  return (children as ReactElement) || <GrayBox width={width} />;
};
